import { z } from "zod";

import { OrgRoleLiteral } from "./enums.js";
import { OrgId, UserId } from "./idTypeBrands.js";

export const AuthenticatedUserOrgDetails = z.object({
  userId: UserId,
  id: OrgId,
  displayName: z.string(),
  orgRole: OrgRoleLiteral,
  email: z.string(),
  userCount: z.number().optional(),
  // The org's user-facing URL handle, used as the URL segment when present.
  // Optional so older servers (which omit it) still validate; falls back to id.
  userFacingId: z.string().optional(),
});

export type AuthenticatedUserOrgDetails = z.infer<
  typeof AuthenticatedUserOrgDetails
>;

export const UnAuthenticatedUserOrgDetails = z.object({
  id: OrgId,
  displayName: z.string(),
  email: z.string(),
  ssoEnforced: z.boolean(),
  // See AuthenticatedUserOrgDetails.userFacingId.
  userFacingId: z.string().optional(),
});

export type UnAuthenticatedUserOrgDetails = z.infer<
  typeof UnAuthenticatedUserOrgDetails
>;

export const UserOrgDetails = z.union([
  AuthenticatedUserOrgDetails,
  UnAuthenticatedUserOrgDetails,
]);

export type UserOrgDetails = z.infer<typeof UserOrgDetails>;
